import { render, staticRenderFns } from "./MedicalCertificateDetailsContent.vue?vue&type=template&id=02265e20&scoped=true"
import script from "./MedicalCertificateDetailsContent.vue?vue&type=script&lang=ts"
export * from "./MedicalCertificateDetailsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02265e20",
  null
  
)

export default component.exports